import { Container } from '@acies/core';
import { Button, Dropdown, IconTitle, LabelText, Spacer, theme } from '@acies/ui';
import PropertiesPanelShowHideButton from './properties-panel-show-hide-button';

export default class TopBar extends Container {
	#order!: IconTitle;
	#number!: LabelText;
	#version!: Dropdown;
	#spacer!: Spacer;
	#name!: LabelText;
	#adresse!: LabelText;
	#city!: LabelText;
	#date!: LabelText;
	#debitor!: Button;
	#showHideButton!: PropertiesPanelShowHideButton;

	public constructor() {
		super();
		this.width = 'fill';
		this.height = 48;
		this.alignment = 'left';
		this.gapHorizontal = 24;
		this.paddingHorizontal = 8;
		this.cornerRadius = 8;
		this.fill = theme.colors.fill.white;
		this.stroke = theme.strokes.soft;
	}

	public get order(): IconTitle {
		if (!this.#order) {
			this.#order = new IconTitle();
			this.#order.icon = 'file-05';
			this.#order.text = 'Ordre';
		}
		return this.#order;
	}

	public get number(): LabelText {
		if (!this.#number) {
			this.#number = new LabelText();
			this.#number.label = 'Nummer';
			this.#number.text = '11907717';
		}
		return this.#number;
	}

	public get version(): Dropdown {
		if (!this.#version) {
			this.#version = new Dropdown();
			this.#version.minWidth = 32;
		}
		return this.#version;
	}

	public get spacer(): Spacer {
		if (!this.#spacer) {
			this.#spacer = new Spacer();
		}
		return this.#spacer;
	}

	public get name(): LabelText {
		if (!this.#name) {
			this.#name = new LabelText();
			this.#name.label = 'Navn';
			this.#name.text = 'Tuija Kullebjörk';
		}
		return this.#name;
	}

	public get adresse(): LabelText {
		if (!this.#adresse) {
			this.#adresse = new LabelText();
			this.#adresse.label = 'Adresse';
			this.#adresse.text = 'Maikkojärvivägen 18';
		}
		return this.#adresse;
	}

	public get city(): LabelText {
		if (!this.#city) {
			this.#city = new LabelText();
			this.#city.label = 'By';
			this.#city.text = '980 62 Junosuando';
		}
		return this.#city;
	}

	public get date(): LabelText {
		if (!this.#date) {
			this.#date = new LabelText();
			this.#date.label = 'Dato';
			this.#date.text = '26. juni 2026';
		}
		return this.#date;
	}

	public get debitor(): Button {
		if (!this.#debitor) {
			this.#debitor = new Button();
			this.#debitor.icon = 'sticker-square';
			this.#debitor.text = 'Debitor Notat';
		}
		return this.#debitor;
	}

	/**
	 * The button that shows and hides the properties panel, at the far end of the bar.
	 *
	 * Here rather than in the panel, so there is somewhere to press while the panel is hidden: a panel that holds its own button has to keep a sliver of itself on screen to hold it. It says nothing to the panel. Its event goes up to the machine, which flips `ConfiguratorModel.propertiesPanelShown`, and the panel reads
	 * that.
	 */
	public get showHideButton(): PropertiesPanelShowHideButton {
		if (!this.#showHideButton) {
			this.#showHideButton = new PropertiesPanelShowHideButton();
		}
		return this.#showHideButton;
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponents([this.order, this.number, this.version, this.spacer, this.name, this.adresse, this.city, this.date, this.debitor, this.showHideButton]);
	}
}
customElements.define('ac-top-bar', TopBar);
